import {
  CommandButtonGroup,
  CommandMenuItem,
  DropdownButton,
} from "@remirror/react-ui";
import { COLORS_LABEL, COLORS_WITH_TRANSPARENCY } from "../../../constants";
import { ColorOrTransparent } from "../../../types";
import { getColorDotStyling } from "../../../utils";

export type BackgroundColorProps = {
  backgroundColor: ColorOrTransparent;
  onBackgroundColorChange: (color: ColorOrTransparent) => void;
};

export const BackgroundColorButtons = ({
  onBackgroundColorChange,
  backgroundColor,
}: BackgroundColorProps) => {
  return (
    <CommandButtonGroup>
      <DropdownButton
        aria-label="Background color"
        icon={
          <div
            className={
              backgroundColor === "transparent"
                ? "transparent-checkerboard"
                : ""
            }
            style={getColorDotStyling(backgroundColor, 16)}
          ></div>
        }
      >
        {COLORS_WITH_TRANSPARENCY.map((color: ColorOrTransparent) => (
          <CommandMenuItem
            key={color}
            commandName="setBackgroundColor"
            onSelect={() => onBackgroundColorChange(color)}
            enabled={true}
            active={color === backgroundColor}
            label={COLORS_LABEL[color]}
            icon={
              <div
                className={
                  color === "transparent" ? "transparent-checkerboard" : ""
                }
                style={getColorDotStyling(color)}
              />
            }
            displayDescription={false}
          />
        ))}
      </DropdownButton>
    </CommandButtonGroup>
  );
};
